export const joystick = (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.6577 15.7639L25.2476 16.676V21.2053L24.6577 22.1174L14.4106 26.7239H13.5903L3.34229 22.1174L2.75244 21.2053V16.676L3.34229 15.7639L12.0005 11.8713V14.0637L6.19092 16.676L14.0005 20.1858L21.8091 16.676L16.0005 14.0637V11.8713L24.6577 15.7639ZM14.4106 22.1946H13.5903L4.75244 18.2219V20.5579L14.0005 24.7151L23.2476 20.5579V18.2219L14.4106 22.1946Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.0005 1.92505C16.2095 1.92518 18.0005 3.71599 18.0005 5.92505C18.0003 7.7886 16.7254 9.35395 15.0005 9.7981V16.5774H13.0005V9.79907C11.2752 9.35517 10.0007 7.78885 10.0005 5.92505C10.0005 3.71591 11.7913 1.92505 14.0005 1.92505ZM14.0005 3.92505C12.8959 3.92505 12.0005 4.82048 12.0005 5.92505C12.0007 7.02945 12.896 7.92505 14.0005 7.92505C15.1048 7.92492 16.0003 7.02937 16.0005 5.92505C16.0005 4.82056 15.1049 3.92518 14.0005 3.92505Z"
      fill="currentColor"
    />
  </>
);
